var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("BaseSidebar", {
    attrs: {
      company: _vm.company,
      currentUser: _vm.currentUser,
      sidebarOpened: _vm.sidebarOpened,
    },
    on: {
      closeSidebar: function ($event) {
        return _vm.$emit("closeSidebar")
      },
    },
    scopedSlots: _vm._u([
      {
        key: "singleItem",
        fn: function ({ sidebarItem }) {
          return [_vm.isOptionalSection(sidebarItem) ? _c("div") : _vm._e()]
        },
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }